const notifyNewrelic = (shouldLogNewrelic, status, source, message) => {
  if (shouldLogNewrelic && window.newrelic) {
    window.newrelic.addPageAction('Location', {
      Status: status,
      Source: source,
      Description: message
    });
  }
};

export default notifyNewrelic;